<card
  [config]="{ maxHeight: 'true' }"
  class="MemberCard"
  data-test-id="memberCardWrapper"
>
  <div data-test-id="memberCardTitleWrapper" title>
    <h5
      class="t-bold MemberCard__Title"
      data-test-id="memberCardTitle"
      aria-label="Card Title"
      data-test-id="cardTitle"
      [innerHTML]="memberName"
    ></h5>
  </div>
  <div data-test-id="memberCardBodyWrapper" body>
    @for (attribute of attributes; track attribute; let i = $index) {
      <model-attribute
        [attr.data-test-id]="'memberCardModelAttribute_' + i"
        [config]="attribute"
        [context]="member"
      ></model-attribute>
    }
  </div>
</card>
